import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import Navbar from '../../Navbar/NavBar';
import Practices from './TabPractices/Practices';
import Games from './TabGames/Games';
import { FILTER_KEYS, GAMES, ON_EXPORT_ALERT, PRACTICES } from '../../../config/constants';
import { fileDownload, getFile, getTeamProps, loadDataPlayersOfLocalStorageIf, paramBuilder } from '../../../helpers/helpers';
import Loader from '../../Shared/Loader';
import { useRouter } from '../../../helpers/customHooks';
import { useDataPlayersDispatch, useDataPlayersState } from '../../../store/hooks';
import { PlayerRoutes, TeamProps } from '../types';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { message, notification } from 'antd';
import { FiltersState } from 'store/types';
import store from 'store';
import { SERVER } from 'config/server.config';

export default () => {
  
  const { match, location } = useRouter<PlayerRoutes>();
  const { dataPlayer } = useDataPlayersState(match.params.playerId);
  const { loadDataPlayersOfLocalStorage } = useDataPlayersDispatch();
  const currentDate = new Date();
  const filterSeasonData = new URLSearchParams(location.search).get(FILTER_KEYS.DATE_RANGE) || '';
  let filterYear = ((match.params.event === GAMES && currentDate.getMonth() <= 7) ? currentDate.getFullYear() - 1 : currentDate.getFullYear()); 
  try{
    filterYear = JSON.parse(filterSeasonData).year;
  }catch (e){
    console.info('JSON Parse', filterSeasonData);
  }
  if (!dataPlayer) {
    if (loadDataPlayersOfLocalStorageIf(match.params.playerId)) { // send playerId and not dataPlayer.playerId because dataPlayer not exist
      loadDataPlayersOfLocalStorage();
      return <Loader style={{ height: '100%' }} forceLoader={true} />;
    } else {
      return <Redirect to={'/players'} />;
    }
  }
  const team: TeamProps = getTeamProps(dataPlayer.meta.teamId) || {};
  if (!team) {
    return <Redirect to={'/players'} />;
  }

  return (
    <>
      <Navbar />
      <Container className="container-00">
        <Row>
          <Col lg={12} xs={12}>
            <div className="header-p">
              <Link
                to={{
                  pathname: (location.state && location.state.toReturn) || '/players',
                  search: (location.state && location.state.toReturnSearch) || `defaultyear=${filterYear}`
                }}
              >
                <div className={'button-back-link'} style={{ cursor: 'pointer' }}>
                  <img src="/assets/images/sprites/left.svg" alt="" height="15px" />
                </div>
              </Link>
              {/*<div className="p-img-01"*/}
              {/*     style={{*/}
              {/*       backgroundImage: `url(https://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/${player.eid}.png)`,*/}
              {/*       width: '50px',*/}
              {/*       backgroundSize: '50px'*/}
              {/*     }}/>*/}
              <div className="p-g-01">
                <label className="p-01">{dataPlayer.meta.name}</label>
                <label className="p-02">
                  <img src={`/assets/images/logos/${team.teamAbbr}.svg`} alt="" height="15px" />
                  {team.teamName}
                  <span>•</span>{`#${dataPlayer.meta.jersey}`}<span>•</span>{dataPlayer.meta.position}
                </label>
              </div>
            </div>
            {match.params.event === PRACTICES ?
              <Practices /> :
              <Games />}
          </Col>
        </Row>
      </Container>
    </>
  );
};
